/**
 * The three answers share one size and one weight on purpose. Refusing has to
 * be as easy to find and to press as accepting (EDPB cookie banner taskforce,
 * 2023): "Acceptă toate" may lead, it may not be the only button that looks
 * like one. A refuse rendered as a faint text link is exactly what regulators
 * have fined.
 */
const consentButtonBase =
  "inline-flex min-h-11 w-full cursor-pointer items-center justify-center rounded-lg border px-4 py-2.5 text-center text-sm font-semibold transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600";

export const consentPrimaryClass = `${consentButtonBase} border-brand-600 bg-brand-600 text-white hover:bg-brand-700`;

export const consentSecondaryClass = `${consentButtonBase} border-ink-300 bg-white text-ink-800 hover:border-brand-600 hover:text-brand-700`;
